class EmailTemplates {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/email-templates`;

  }

  async createUserEmailTemplate(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getAllEmailTemplates() {

    const path = this.basePath;

    return this.apiClient.get(path, {}, {});

  }

  async updateEmailTemplateSubjectAndHTMLContentById(templateId, payload) {

    const path = `${this.basePath}/:templateId`;

    return this.apiClient.put(path, { templateId }, {}, payload);

  }

  async deleteUserEmailTemplateById(templateId) {

    const path = `${this.basePath}/:templateId`;

    return this.apiClient.delete(path, { templateId }, {});

  }

}

export default EmailTemplates;